import { useEffect, useRef } from "react";
import { useSearch } from "@tanstack/react-router";
import { api } from "@/api";
import type { Party } from "@/api/types";

/** Starts a form with the customer or supplier the address names, when it was opened from their page. */
export function usePartyFromAddress(key: "customer" | "supplier", choose: (party: Party) => void) {
  const search = useSearch({ strict: false }) as { customer?: string; supplier?: string };
  const id = search[key];
  const latest = useRef(choose);
  latest.current = choose;

  useEffect(() => {
    if (!id) return;
    let current = true;
    void api.parties.get(id).then((party) => {
      if (current) latest.current(party);
    });
    return () => {
      current = false;
    };
  }, [id]);
}
